const FooterBag_SVG = (props) => {
	return (
			<img src="/images/Footer/footer_bag.svg"
			     width={761}
			     height={553}
			     alt=""
			     loading="lazy"
			     decoding="async"
			     {...props}/>
	)
}
export default FooterBag_SVG;
